import { SVGProps, Ref, forwardRef } from 'react'
const SvgLivePortrait = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23.25 18.75v3a1.5 1.5 0 0 1-1.5 1.5h-3M18.75.75h3a1.5 1.5 0 0 1 1.5 1.5v3M.75 5.25v-3a1.5 1.5 0 0 1 1.5-1.5h3M5.25 23.25h-3a1.5 1.5 0 0 1-1.5-1.5v-3M7.875 8.625a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 0 0-8.25 0v0ZM18.75 19.5a6.964 6.964 0 0 0-13.5 0"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgLivePortrait)
export default ForwardRef
